export enum PublicAreaStates {
  DIRTY = 0,
  CLEAN = 1,
  ACCEPTED = 2

}
